import Routes from '@models/routes';
import { createSectionFlowRoutingService } from '@services/factories';
import {
    Observable,
    Subject
} from 'rxjs';
import {
    filter,
    map,
    switchMap
} from 'rxjs/operators';

export enum FlowAction {
    Start,
    Decline,
    Reset,
    DocumentUploaded,
    ConfirmEmployeeInfo,
    ESign,
    GoBack
}

export const onboardingFlowActions = new Subject<FlowAction>();

export const previousPageOnboardingReview: Observable<FlowAction> = (
    onboardingFlowActions.pipe(
        filter(event => event === FlowAction.GoBack)
    )
);

export const finishOnboardingReview: Observable<Routes> = (
    onboardingFlowActions.pipe(
        filter(event => [
            FlowAction.Decline,
            FlowAction.Reset,
            FlowAction.ESign
        ].includes(event)),
        map(() => Routes.Section2ThankYou)
    )
);

export const startOnboardingReview: Observable<Routes> = (
    onboardingFlowActions.pipe(
        filter(event => event === FlowAction.Start),
        switchMap(() => createSectionFlowRoutingService().routeSectionFromStatusAsync())
    )
);

const innerRoutes = new Map<FlowAction, Routes>([
    [FlowAction.ConfirmEmployeeInfo, Routes.Section2CompleteI9],
    [FlowAction.DocumentUploaded, Routes.Section2Documents]
]);
export const continueOnboardingReview: Observable<Routes> = (
    onboardingFlowActions.pipe(
        filter(event => innerRoutes.has(event)),
        map(event => {
            const route = innerRoutes.get(event);
            if (!route) {
                throw new Error('Unhandled flow action');
            }

            return route;
        })
    )
);



// WEBPACK FOOTER //
// ./src/flows/onboarding-review/navigation.ts